import React, { useCallback, useContext, useEffect, useState } from "react";
import SmoothSlider from "components/SmoothSlider/SmoothSlider";
import "./InformationDescriptionSide.css";

import { Mail, Phone } from "lucide-react";
import { motion } from "framer-motion";
import { PAccordion, PDivider } from "@porsche-design-system/components-react";
import { PTable, PTableBody, PTableCell, PTableRow } from '@porsche-design-system/components-react';
// Eliminamos axiosInstance import ya que no lo necesitamos
// import axiosInstance from "axiosConfig";
import useTexts from "mainApp/assets/utils/hooks/useTexts";

import VitalInfoComponent from "components/VitalInfoComponent/VitalInfoComponent";
import CallToBook from "components/CallToBook/CallToBook";
import { spacingFluidLarge, spacingFluidMedium, spacingFluidSmall, spacingFluidXSmall } from "@porsche-design-system/components-js/styles";
import { IsRotatedContext } from "mainApp/assets/utils/context/isRotatedContext";

const InformationDescriptionSide = ({ tour, isPhone }) => {
    const { isRotated } = useContext(IsRotatedContext);
    const { texts } = useTexts('tourInfo');
    // Eliminamos el estado 'images' ya que no necesitamos manejar el estado de carga
    // const [images, setImages] = useState([]);

    const [isOpen1, setIsOpen1] = useState(false);
    const [isOpen2, setIsOpen2] = useState(false);
    const [isOpen3, setIsOpen3] = useState(false);
    const [isOpen4, setIsOpen4] = useState(false);

    const onUpdate1 = useCallback((e) => {
        setIsOpen1(e.detail.open);
    }, []);

    const onUpdate2 = useCallback((e) => {
        setIsOpen2(e.detail.open);
    }, []);

    const onUpdate3 = useCallback((e) => {
        setIsOpen3(e.detail.open);
    }, []);

    const onUpdate4 = useCallback((e) => {
        setIsOpen4(e.detail.open);
    }, []);

    // Definimos la constante con las imágenes para cada tipo de habitación
    const roomImages = {
        Business: [
            "https://www.thestablegame.com/hotel/B1.webp",
            "https://www.thestablegame.com/hotel/B2.webp",
            "https://www.thestablegame.com/hotel/B3.webp",
        ],
        Coach: [
            "https://www.thestablegame.com/hotel/C1.webp",
            "https://www.thestablegame.com/hotel/C2.webp",
            "https://www.thestablegame.com/hotel/C3.webp",
        ],
        Deluxe: [
            "https://www.thestablegame.com/hotel/D1.webp",
            "https://www.thestablegame.com/hotel/D2.webp",
            "https://www.thestablegame.com/hotel/D3.webp",
        ],
    };

    // Obtenemos las imágenes correspondientes al tipo de habitación
    const images = roomImages[tour.room] || [];

    if (!tour) return null;

    // Definimos la constante con el contenido según el tipo de habitación
    const roomContent = {
        Business: {
            heading: "Detalles de Business Class",
            caption: "Características de Business Class",
            content: ["Asientos premium", "Espacio adicional para las piernas", "Bebidas de cortesía"]
        },
        Coach: {
            heading: "Detalles de Coach Class",
            caption: "Características de Coach Class",
            content: ["Asientos estándar", "Entretenimiento a bordo", "Snacks disponibles para compra"]
        },
        Deluxe: {
            heading: "Detalles de Deluxe Class",
            caption: "Características de Deluxe Class",
            content: ["Asientos de lujo", "Cabina privada", "Comidas gourmet"]
        }
    };

    // Obtenemos el contenido correspondiente al tipo de habitación
    const roomTypeContent = roomContent[tour.room] || {};

    const rotatedStyle = {
        minHeight: isRotated ? "" : "40svh",
    };

    return (
        <div className="informationDescriptionSide"
            style={{ gap: isPhone ? "" : spacingFluidSmall }}
        >
            {
                isPhone &&
                (
                    <CallToBook isSimple={true} isPhone={isPhone} tour={tour} />
                )
            }
            <div className="infoSliderContainer"
                style={{
                    marginTop: isPhone ? spacingFluidLarge : "",
                    marginBottom: isPhone ? spacingFluidSmall : "",
                    marginLeft: isPhone ? spacingFluidSmall : spacingFluidMedium,
                    marginRight: isPhone ? spacingFluidSmall : spacingFluidMedium,
                    ...rotatedStyle
                }}
            >
                <motion.div
                    initial={{ opacity: 0, y: -50 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}
                    className="smoothContainerInfoSide"
                    style={{ rotatedStyle }}
                >
                    <SmoothSlider images={images} />
                </motion.div>
            </div>

            <PDivider direction={"vertical"} className="vDivider" />

            <div className="infoArea"
                style={{ paddingTop: isPhone ? spacingFluidSmall : "" }}
            >
                <VitalInfoComponent tour={tour} isMulti={true} />

                <PDivider className="hDivider"
                    style={{
                        marginTop: isPhone ? spacingFluidSmall : "",
                        marginBottom: isPhone ? spacingFluidXSmall : "",
                    }}
                />

                {/* Primer PAccordion modificado */}
                <PAccordion heading={roomTypeContent.heading || "Cargando..."} open={isOpen1} onUpdate={onUpdate1}>
                    <PTable caption={roomTypeContent.caption || "Cargando..."}>
                        <PTableBody>
                            {roomTypeContent.content && roomTypeContent.content.map((item, index) => (
                                <PTableRow key={index}>
                                    <PTableCell>
                                        {item}
                                    </PTableCell>
                                </PTableRow>
                            ))}
                        </PTableBody>
                    </PTable>
                </PAccordion>

                {/* Los demás PAccordions permanecen sin cambios */}
                <PAccordion heading={texts?.accordion?.info?.head || "Cargando..."} open={isOpen2} onUpdate={onUpdate2}>
                    <PTable caption={texts?.accordion?.info?.caption || "Cargando..."}>
                        <PTableBody>
                            {Object.keys(texts?.accordion?.info?.content || {}).map((key, index) => (
                                <PTableRow key={index}>
                                    <PTableCell multiline={true}>
                                        {texts?.accordion?.info?.content[key] || "Cargando..."}
                                    </PTableCell>
                                </PTableRow>
                            ))}
                        </PTableBody>
                    </PTable>
                </PAccordion>

                <PAccordion heading={texts?.accordion?.legal?.head || "Cargando..."} open={isOpen3} onUpdate={onUpdate3}>
                    <PTable caption={texts?.accordion?.legal?.caption || "Cargando..."}>
                        <PTableBody>
                            {Object.keys(texts?.accordion?.legal?.content || {}).map((key, index) => (
                                <PTableRow key={index}>
                                    <PTableCell multiline={true}>
                                        {texts?.accordion?.legal?.content[key] || "Cargando..."}
                                    </PTableCell>
                                </PTableRow>
                            ))}
                        </PTableBody>
                    </PTable>
                </PAccordion>

                {/* Contenido estático */}
                <PAccordion heading={texts?.accordion?.further?.head || "Cargando..."} open={isOpen4} onUpdate={onUpdate4}>
                    <PTable caption={texts?.accordion?.further?.caption || "Cargando..."}>
                        <PTableBody>
                            <PTableRow>
                                <PTableCell multiline={false}>
                                    <p className="text-sm text-gray-700">{texts?.accordion?.further?.content || "Cargando..."}</p>
                                </PTableCell>
                            </PTableRow>
                            <PTableRow>
                                <PTableCell>
                                    <div className="flex items-center space-x-3">
                                        <Phone className="h-5 w-5 text-gray-500" />
                                        &nbsp;
                                        <a href={`https://wa.me/${process.env.REACT_APP_PHONE1}`} className="text-sm text-gray-600 hover:text-gray-900">
                                            {process.env.REACT_APP_PHONE1}
                                        </a>
                                    </div>
                                </PTableCell>
                            </PTableRow>
                            <PTableRow>
                                <PTableCell>
                                    <div className="flex items-center space-x-3">
                                        <Mail className="h-5 w-5 text-gray-500" />
                                        &nbsp;
                                        <a href={`mailto:${process.env.REACT_APP_EMAIL}`} className="text-sm text-gray-600 hover:text-gray-900">
                                            {process.env.REACT_APP_EMAIL}
                                        </a>
                                    </div>
                                </PTableCell>
                            </PTableRow>
                        </PTableBody>
                    </PTable>
                </PAccordion>
            </div>
        </div>
    );
};

export default InformationDescriptionSide;
